/* ==========================================================================
   Wohlform — Reveal-Sicherheitsnetz (2026-08-12)

   Fehlerbild: die komplette Produktbeschreibung blieb unsichtbar — der Kunde
   scrollte an einer leeren cremefarbenen Flaeche vorbei.

   Ursache: theme.css setzt jeden .reveal-Block auf opacity:0. theme.js blendet
   ihn erst wieder ein, wenn 12 % des Blocks im Bild sind (IntersectionObserver,
   threshold .12, rootMargin '0px 0px -8% 0px'). Der Beschreibungsblock ist am
   Handy 6.181px hoch, der Bildschirm 844px — bildschirmfuellend also nur
   844 x 0,92 / 6.181 = 12,56 %. Am Desktop (900px) sind es 12,0002 %.
   Die Schwelle wird nur um Haaresbreite erreicht; bei etwas kleinerem Fenster
   NIE — dann bleibt der Text dauerhaft weg.

   Fix: bei jedem Scroll-Frame die ECHTEN Positionen nachpruefen und einblenden,
   was tatsaechlich im Bild ist. Bloecke, die hoeher als der Bildschirm sind,
   werden sofort eingeblendet — fuer sie ist die Schwelle nicht zuverlaessig
   erreichbar, und eine Animation ueber mehrere Bildschirmhoehen sieht niemand.
   theme.js bleibt unangetastet: der Observer darf weiter frueh einblenden,
   wir fangen nur ab, was er verpasst. Gleiches Muster wie das Sicherheitsnetz
   fuer .wf-reveal in layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  function viewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  function sweep() {
    var vh = viewportHeight();
    var list = document.querySelectorAll('.reveal:not(.is-in)');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var r = el.getBoundingClientRect();
      var tooTall = r.height > vh;              /* Schwelle nicht erreichbar */
      var inView  = r.top < vh * 0.92 && r.bottom > 0;
      if (tooTall || inView) el.classList.add('is-in');
    }
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { sweep(); ticking = false; });
  }

  sweep();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', sweep, { passive: true });
  window.addEventListener('load', sweep);
  document.addEventListener('DOMContentLoaded', sweep);
  /* Bilder aendern die Hoehen noch nach dem ersten Durchlauf. */
  setTimeout(sweep, 1200);
  setTimeout(sweep, 4000);
})();

/* ==========================================================================
   Wohlform — Produktseiten-Fix Handy (2026-08-11)

   1) Handy: Marke · Titel · Bewertungen · Preis wandern ÜBER das Produktbild,
      damit der Kunde sofort sieht, was er hier kauft und was es kostet.
   2) Der Kaufen-Button nennt das Paket ("In den Warenkorb — 2er-Pack 117,14 €"),
      damit der Preis oben (Stückpreis) dem Preis im Button nicht mehr widerspricht.
   3) Eigene Kauf-Leiste unten statt der App-Leiste: EIN Preis, deutscher Text,
      sie löst das echte Produktformular aus (also gelten Ausverkauft-Sperre und
      Fehlermeldung genauso wie beim Hauptbutton).
   4) Die Leiste legt sich nie über einen anderen fixierten Balken (Cookie-Banner).

   Läuft VOR dem Scroll-Reveal-Skript in layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var MOBILE = '(max-width:749px)';

  var form = document.getElementById('ProductForm');
  if (!form) return;

  var prod  = document.querySelector('.product');
  var info  = document.querySelector('.product__info');
  var btn   = form.querySelector('button[type=submit]');
  var qtyIn = form.querySelector('input[name=quantity]');
  var row   = document.querySelector('.product-form__row');
  if (!prod || !info || !btn) return;

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia(MOBILE).matches);
  }

  /* ------------------------------------------------------------------
     1) Kopfbereich über das Bild (nur Handy)
     ------------------------------------------------------------------ */
  var head = null;

  function buildHead() {
    if (head || !isMobile()) return;

    head = document.createElement('div');
    head.className = 'wf-pdp-head wf-no-reveal';
    prod.insertBefore(head, prod.firstElementChild);

    var cat   = info.querySelector('.product__cat');
    var title = info.querySelector('h1.product__title');
    var rev   = info.querySelector('a[href="#bewertungen"]');
    var price = info.querySelector('.product__price');

    [cat, title, rev, price].forEach(function (el) {
      if (el) head.appendChild(el);
    });

    /* Diese Elemente dürfen nie wieder wegblenden — sie sind der Grund,
       warum der Kunde überhaupt weiterliest. */
    [head, cat, title, rev, price].forEach(function (el) {
      if (!el) return;
      el.classList.add('wf-no-reveal');
      el.classList.remove('wf-reveal', 'wf-up', 'wf-left', 'wf-right');
      el.style.opacity = '';
      el.style.transform = '';
    });
  }

  /* ------------------------------------------------------------------
     2) Menge im Button sichtbar machen
        Kaching stellt die Menge auf 2 und schreibt den 2er-Preis in den
        Button. Oben stand weiter der Stückpreis -> zwei Preise, ein Kunde,
        kein Kauf. Wir schreiben die Menge dazu, statt einen Preis zu
        verstecken: "In den Warenkorb — 2er-Pack 117,14 €".
     ------------------------------------------------------------------ */
  var busy = false;

  function currentQty() {
    var v = qtyIn ? parseInt(qtyIn.value, 10) : 1;
    return (v > 0 && isFinite(v)) ? v : 1;
  }

  function syncQtyBadge() {
    if (busy) return;
    var priceEl = btn.querySelector('#PriceInline');
    var badge   = btn.querySelector('.wf-qty-badge');
    var q       = currentQty();

    /* Ohne Preis im Button (z. B. "Ausverkauft") gibt es nichts zu kennzeichnen. */
    if (!priceEl || q <= 1) {
      if (badge && badge.parentNode) {
        busy = true; badge.parentNode.removeChild(badge); busy = false;
      }
      return;
    }

    /* NICHT "2×" — das liest sich wie "zwei mal 117,14 €". Der Preis im
       Button ist der GESAMTpreis des Pakets, also muss da "2er-Pack" stehen:
       "In den Warenkorb — 2er-Pack 117,14 €" neben dem Stückpreis oben. */
    var txt = q + 'er-Pack ';
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'wf-qty-badge';
      badge.textContent = txt;
      busy = true; priceEl.parentNode.insertBefore(badge, priceEl); busy = false;
    } else if (badge.textContent !== txt) {
      busy = true; badge.textContent = txt; busy = false;
    } else if (badge.nextSibling !== priceEl) {
      /* Kaching hat den Button neu aufgebaut — Reihenfolge wiederherstellen. */
      busy = true; priceEl.parentNode.insertBefore(badge, priceEl); busy = false;
    }
  }

  /* ------------------------------------------------------------------
     3) Eigene Kauf-Leiste
     ------------------------------------------------------------------ */
  var bar = null, barBtn = null, barTitle = null, barVariant = null;

  function buildBar() {
    if (bar) return;

    bar = document.createElement('div');
    bar.id = 'WfSticky';
    /* KEIN 'wf-no-reveal' hier! Dazu gibt es in theme.liquid die Regel
       '.js .wf-no-reveal{transform:none !important}' — die haette unsere
       Versteck-Verschiebung ueberschrieben und die Leiste waere IMMER
       sichtbar gewesen. Das Reveal-Skript fasst ohnehin nur .wf-reveal an,
       und die Leiste hat diese Klasse nicht. */
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Schnellkauf');

    var img = document.getElementById('ProductImage');
    var pic = '';
    if (img && img.src) {
      pic = '<img class="wf-sticky__img" src="' + img.src + '" alt="" aria-hidden="true">';
    }

    bar.innerHTML =
      pic +
      '<div class="wf-sticky__info">' +
        '<div class="wf-sticky__title"></div>' +
        '<div class="wf-sticky__variant"></div>' +
      '</div>' +
      '<button type="button" class="btn btn--primary wf-sticky__btn"></button>';

    document.body.appendChild(bar);
    document.body.classList.add('wf-has-sticky');

    barTitle   = bar.querySelector('.wf-sticky__title');
    barVariant = bar.querySelector('.wf-sticky__variant');
    barBtn     = bar.querySelector('.wf-sticky__btn');

    var t = document.querySelector('h1.product__title');
    barTitle.textContent = t ? (t.textContent || '').trim() : '';

    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      /* Das echte Formular auslösen: dadurch greifen Ausverkauft-Sperre,
         Mengen-/Bundle-Logik und die Fehlermeldung aus theme.js unverändert. */
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

    /* Bild mitziehen, wenn der Kunde die Farbe wechselt. */
    var barImg = bar.querySelector('.wf-sticky__img');
    if (barImg && img) {
      new MutationObserver(function () { barImg.src = img.src; })
        .observe(img, { attributes: true, attributeFilter: ['src'] });
    }
  }

  /* Der Text der Leiste ist eine 1:1-Spiegelung des echten Buttons.
     Damit KÖNNEN die beiden gar nicht mehr verschiedene Preise zeigen. */
  function mirrorBar() {
    if (!bar) return;
    var label = (btn.textContent || '').replace(/\s+/g, ' ').trim();
    if (barBtn.textContent !== label) barBtn.textContent = label;
    if (barBtn.disabled !== !!btn.disabled) barBtn.disabled = !!btn.disabled;

    var checked = form.querySelectorAll('input[data-opt]:checked');
    var parts = [];
    Array.prototype.forEach.call(checked, function (i) { parts.push(i.value); });
    var v = parts.join(' · ');
    if (barVariant.textContent !== v) barVariant.textContent = v;
  }

  /* Ein-/ausblenden: sobald die echte Kaufzeile oben rausgescrollt ist. */
  function toggleBar() {
    if (!bar || !row) return;
    var r = row.getBoundingClientRect();
    var past = r.bottom < 8;
    var drawerOpen = !!document.querySelector('#CartDrawer.is-open');
    var on = past && !drawerOpen;
    if (bar.classList.contains('is-on') !== on) bar.classList.toggle('is-on', on);
  }

  /* 4) Nicht stapeln: über jedem anderen fixierten Balken am unteren Rand sitzen. */
  function liftBar() {
    if (!bar) return;
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var off = 0;

    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === bar) return;
      var s;
      try { s = getComputedStyle(el); } catch (e) { return; }
      if (s.position !== 'fixed' || s.display === 'none' ||
          s.visibility === 'hidden' || parseFloat(s.opacity) < 0.05) return;
      var r = el.getBoundingClientRect();
      if (r.height < 24 || r.width < 200) return;
      if (r.height > vh * 0.6) return;               /* Vollbild-Overlay: nicht ausweichen */
      if (r.bottom > vh - 6 && r.top > vh * 0.4) {
        off = Math.max(off, Math.round(r.height));
      }
    });

    if (bar.dataset.off !== String(off)) {
      bar.dataset.off = String(off);
      bar.style.bottom = off + 'px';
      /* Die Versteck-Position muss den Versatz kennen: sonst schiebt
         translateY(115%) die Leiste nur um ihre eigene Hoehe nach unten und
         sie lugt genau um "off" Pixel oben aus dem Bildschirmrand heraus. */
      bar.style.setProperty('--wf-lift', off + 'px');
      document.body.style.paddingBottom = (off + 76) + 'px';
    }
  }

  /* ------------------------------------------------------------------
     Takt
     ------------------------------------------------------------------ */
  function tick() {
    syncQtyBadge();
    mirrorBar();
    toggleBar();
    liftBar();
  }

  buildHead();
  buildBar();
  tick();

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { toggleBar(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', tick, { passive: true });

  /* Kaching setzt die Menge per .value — das löst KEIN Event aus.
     Darum zusätzlich ein ruhiger Takt. */
  new MutationObserver(syncQtyBadge).observe(btn, {
    childList: true, subtree: true, characterData: true
  });
  form.addEventListener('change', tick);
  form.addEventListener('input', tick);
  setInterval(tick, 800);
  window.addEventListener('load', tick);
})();
